<style>


</style>

<template>

    <div class="course-schedules-filter">

        <div class="mb-3 row">
            <div class="col-md">
                <select class="form-select" v-model="selectedFilters.path" title="Path" @change="runFilterSchedules()">
                    <option :value="{}">all paths</option>
                    <option v-for="path in filters.paths" :value="path">{{ path.name }}</option>
                </select>
            </div>
            <div class="col-md">
                <select class="form-select" v-model="selectedFilters.course" title="courses"
                        @change="runFilterSchedules()">
                    <option :value="{}">all courses</option>
                    <option v-for="course in filters.courses" :value="course">{{ course.name }}</option>
                </select>
            </div>
            <div class="col-md">
                <select class="form-select" v-model="selectedFilters.trainer" title="trainers"
                        @change="runFilterSchedules()">
                    <option :value="{}">all trainers</option>
                    <option v-for="trainer in filters.trainers" :value="trainer">
                        {{ trainer.name }}
                    </option>
                </select>
            </div>
            <div class="col-md">
                <select class="form-select" v-model="selectedFilters.location" title="locations"
                        @change="runFilterSchedules()">
                    <option :value="{}">all locations</option>
                    <option v-for="location in filters.locations" :value="location">{{ location.name }}</option>
                </select>
            </div>
            <div class="col-md">
                <select class="form-select" v-model="selectedFilters.guest" title="guests"
                        @change="runFilterSchedules()">
                    <option :value="{}">all guests</option>
                    <option v-for="guest in filters.guests" :value="guest">
                        [{{ guest.booking.name }}] - {{ guest.user.name }}
                    </option>
                </select>
            </div>
        </div>

        <div class="clearfix"></div>

    </div>

</template>

<script>

export default {

    props: {
        course_schedules: Array,
        library: Object
    },
    data() {
        return {
            courseSchedules: [],
            courseSchedulesFiltered: [],
            filters: {
                paths: [],
                trainers: [],
                locations: [],
                courses: []
            },
            selectedFilters: {
                path: {},
                trainer: {},
                location: {},
                course: {},
                guest: {}
            }
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.courseSchedules = this.course_schedules;
            _(this.courseSchedules).sortBy('from');
            if (this.library) {
                if (this.library.paths) {
                    this.filters.paths = this.library.paths;
                }
                if (this.library.trainers) {
                    this.filters.trainers = this.library.trainers;
                }
                if (this.library.locations) {
                    this.filters.locations = this.library.locations;
                }
                if (this.library.courses) {
                    this.filters.courses = this.library.courses;
                }
                if (this.library.guests) {
                    this.filters.guests = this.library.guests;
                    _(this.filters.guests).sortBy(function(o) { return o.booking.number; });
                }
            } else {
                this.fillFilters();
            }
            if (!this.selectedFilters.path.id && this.filters.paths.length > 0) {
                this.selectedFilters.path = this.filters.paths[0];
            }
            this.runFilterSchedules();
        },

        filterSchedules(courseSchedules) {
            let courseSchedulesFiltered = [];
            for (let i = 0; i < courseSchedules.length; i++) {
                let c = courseSchedules[i];
                let select = c;
                let failed = false;
                if (this.selectedFilters.guest && this.selectedFilters.guest.id) {
                    if (c.guest_ids && Array.isArray(c.guest_ids) && _.includes(c.guest_ids, this.selectedFilters.guest.user.id)) {
                        select = c;
                    } else {
                        failed = true;
                        continue;
                    }
                }
                if (this.selectedFilters.path && this.selectedFilters.path.id) {
                    if (c.path && c.path.id === this.selectedFilters.path.id) {
                        select = c;
                    } else {
                        failed = true;
                        continue;
                    }
                }
                if (this.selectedFilters.trainer && this.selectedFilters.trainer.id) {
                    if (c.trainer && c.trainer.id === this.selectedFilters.trainer.id) {
                        select = c;
                    } else {
                        failed = true;
                        continue;
                    }
                }
                if (this.selectedFilters.location && this.selectedFilters.location.id) {
                    if (c.location && c.location.id === this.selectedFilters.location.id) {
                        select = c;
                    } else {
                        failed = true;
                        continue;
                    }
                }
                if (this.selectedFilters.course && this.selectedFilters.course.id) {
                    if (c.course.id === this.selectedFilters.course.id) {
                        select = c;
                    } else {
                        failed = true;
                        continue;
                    }
                }
                if (select && !failed) {
                    courseSchedulesFiltered.push(select);
                }
            }
            this.courseSchedulesFiltered = courseSchedulesFiltered;

            return this.courseSchedulesFiltered;

        },

        fillFilters() {
            const schedules = this.courseSchedules;
            const paths = [];
            const trainers = [];
            const courses = [];
            const locations = [];
            for (let i = 0; i < schedules.length; i++) {
                if (schedules[i].path) {
                    paths.push(schedules[i].path);
                }
                if (schedules[i].trainer) {
                    trainers.push(schedules[i].trainer);
                }
                if (schedules[i].course) {
                    courses.push(schedules[i].course);
                }
                if (schedules[i].location) {
                    locations.push(schedules[i].location);
                }
            }
            if (this.filters.courses.length === 0) {
                this.filters.courses = _.uniqBy(courses, 'id');
            }
            if (this.filters.paths.length === 0) {
                this.filters.paths = _.uniqBy(paths, 'id');
            }
            if (this.filters.trainers.length === 0) {
                this.filters.trainers = _.uniqBy(trainers, 'id');
            }
            if (this.filters.trainers.length === 0) {
                this.filters.locations = _.uniqBy(trainers, 'id');
            }
        },

        runFilterSchedules() {
            this.filterSchedules(this.courseSchedules);
            this.$emit('filtered', {
                course_schedules: this.courseSchedulesFiltered,
                filters: this.selectedFilters
            });
        },
    },

    watch: {
        course_schedules(newVal, oldVal) {
            this.init();
        },
        library(newVal, oldVal) {
            this.init();
        }
    },
    computed: {}
}
</script>
